import region from '../../../utils/region'
import * as merge from 'lodash/merge'
import * as cloneDeep from 'lodash/cloneDeep'

import {KURGAN} from '../../../config/region.js'

// charts' colors
const purpley = '#8c67e3'
const lightTeal = '#85dbd9'
const butterscotch = '#fbc040'
const seafoamBlue = '#55bad2'
const azul = '#2971e4'
const dodgerBlueTwo = '#5190f5'
const lightTan = '#facdaa'
const rosyPink = '#f46c8b'
const yellowish = '#fbe863'
const dodgerBlueThree = '#3b83fb'
const blue = '#4086f7'
const blueOpacity = 'rgba(244, 108, 139, 0)'
const red = '#f44336'
const redOpacity = 'rgba(244, 67, 54, 0)'
export const grey = 'rgba(189, 195, 199, 1)'
const isFloat = (n) => Number(n) === n && n % 1 !== 0

const fillColorPlanOptions = {
  name: 'План',
  fillColor: {
    linearGradient: {
      x1: 0,
      y1: 0,
      x2: 0,
      y2: 1
    },
    stops: [
      [0, blue],
      [1, blueOpacity]
    ]
  }
}
const fillColorFactOptions = {
  name: 'Факт',
  fillColor: {
    linearGradient: {
      x1: 0,
      y1: 0,
      x2: 0,
      y2: 1
    },
    stops: [
      [0, red],
      [1, redOpacity]
    ]
  }
}

const chartOptionsData = {
  // мусорные контейнеры
  msnContainer: {
    options: {
      documentTitle: 'Мусорные контейнеры',
      legend: {
        // layout: 'vertical',
        // verticalAlign: 'middle',
        align: 'center',
        // itemWidth: 195,
        itemMarginTop: 5
      },
      chart: {
        type: 'pie',
        events: {
          // create in donut chart caption on center
          addSeries: function (event, cb) {
            const setPosition = () => {
              setTimeout(() => {
                let textX = this.plotLeft + (this.plotWidth * 0.5)
                let textY = this.plotTop + (this.plotHeight * 0.5)

                let w = this._pieText.clientWidth
                let h = this._pieText.clientHeight
                this._pieText.style.left = `${textX - (w / 2)}px`
                this._pieText.style.top = `${textY - (h / 2)}px`
              }, 200)
            }

            if (!this._pieText) {
              window.addEventListener('resize', setPosition)
              this._pieText = document.createElement('div')
            }

            let seriesYSum = 0
            try {
              event.options.data.forEach(v => {
                seriesYSum = +seriesYSum + (+v.y || 0)
              })
            } catch (e) {
              console.log(e.toString())
            }

            this._pieText.style.position = 'absolute'
            this._pieText.innerHTML = `<span class="pie-donut-caption">${seriesYSum}</span></span>`

            this.container.appendChild(this._pieText)

            setPosition()
          }
        }
      },
      title: '',
      yAxis: {
        title: ''
      },
      plotOptions: {
        pie: {
          innerSize: '70%',
          name: 'Количество',
          allowPointSelect: true,
          cursor: 'pointer',
          dataLabels: {
            enabled: false
          },
          showInLegend: true
        }
      },
      colors: [lightTeal, purpley]
    }
  },
  // разпределение отходов
  garbageOutput: {
    options: {
      documentTitle: 'Распределение отходов',
      legend: {
        // layout: 'vertical',
        // verticalAlign: 'middle',
        align: 'center',
        // itemWidth: 195,
        itemMarginTop: 5
      },
      chart: {
        type: 'pie',
        events: {
          // create in donut chart caption on center
          addSeries: function (event, cb) {
            const setPosition = () => {
              setTimeout(() => {
                let textX = this.plotLeft + (this.plotWidth * 0.5)
                let textY = this.plotTop + (this.plotHeight * 0.5)

                let w = this._pieText.clientWidth
                let h = this._pieText.clientHeight
                this._pieText.style.left = `${textX - (w / 2)}px`
                this._pieText.style.top = `${textY - (h / 2)}px`
              }, 200)
            }

            if (!this._pieText) {
              window.addEventListener('resize', setPosition)
              this._pieText = document.createElement('div')
            }

            let seriesYSum = event.options.data.total_garbage_sum

            this._pieText.style.position = 'absolute'
            this._pieText.innerHTML = `<span class="pie-donut-caption">${seriesYSum}</span></span>`

            this.container.appendChild(this._pieText)

            setPosition()
          }
        }
      },
      title: '',
      yAxis: {
        title: ''
      },
      plotOptions: {
        pie: {
          colorByPoint: true,
          innerSize: '70%',
          name: 'Количество',
          allowPointSelect: true,
          cursor: 'pointer',
          dataLabels: {
            enabled: false
          },
          showInLegend: true
        },
      },
      colors: [lightTan, purpley, rosyPink, yellowish, yellowish],
      tooltip: {
        pointFormat: '<b>{point.percentage:.1f}%</b> <br>{point.data} тонн'
      }
    }
  },
  // образование отходов
  garbageProduction: {
    options: {
      documentTitle: 'Образование отходов, тыс. тонн/год',
      chart: {
        // height: '37%',
        type: 'bar',
        marginTop: 0,
        marginBottom: 0
      },
      title: '',
      xAxis: {
        tickInterval: 2
      },
      plotOptions: {
        bar: {
          column: {
            colorByPoint: true,
          },
          // pointWidth: 17,
          dataLabels: {
            enabled: true
          }
        }
      },
      legend: {
        enabled: false
      },
      credits: {
        enabled: false
      },
      tooltip: {
        pointFormat: '<b>{point.y}</b>'
      },
      yAxis: {
        title: ''
      },
      colors: [dodgerBlueThree]
    }
  },
  // динамика обращения с отходами
  garbageHandlingDynamic: {
    series: [
      {
        name: '',
        data: []
      }
    ],
    options: {
      documentTitle: 'Динамика обращения с отходами',
      legend: {
        itemMarginTop: 5
      },
      chart: {
        type: 'column'
      },
      title: '',
      xAxis: {
        title: {
          text: 'год',
          style: { fontSize: 10 }
        },
        categories: []
      },
      yAxis: {
        title: {
          text: 'тыс. тонн/год',
          style: { fontSize: 10 }
        }
      },
      tooltip: {
        pointFormat: '{series.name}: <b>{point.y}</b>'
      },
      plotOptions: {
        series: {
          column: {
            colorByPoint: true,
          },
          animation: {
            duration: 400
          }
        }
      },
      colors: [lightTan, purpley, rosyPink, yellowish, yellowish]
    }
  },
  // объем образования отходов
  garbageVolume: {
    options: {
      documentTitle: 'Объем образования отходов, %',
      legend: {
        itemWidth: 165,
        align: 'center',
        itemMarginTop: 5
      },
      chart: {
        type: 'pie'
      },
      title: '',
      yAxis: {
        title: ''
      },
      plotOptions: {
        pie: {
          innerSize: '70%',
          name: 'Объем',
          allowPointSelect: true,
          cursor: 'pointer',
          dataLabels: {
            enabled: false
          },
          showInLegend: true
        }
      },
      tooltip: {
        pointFormat: '{series.name}: <b>{point.y}%</b>'
      },
      credits: {
        enabled: false
      },
      colors: [lightTeal, dodgerBlueTwo, butterscotch, seafoamBlue, lightTan, purpley, rosyPink, yellowish]
    }
  },
  // места сбора и накопления
  msn: {
    options: {
      documentTitle: 'Места сбора и накопления отходов',
      legend: {
        verticalAlign: 'middle',
        align: 'right',
        layout: 'vertical',
        itemMarginTop: 5
      },
      chart: {
        renderTo: 'chart3',
        type: 'pie'
      },
      tooltip: {
        pointFormat: '<b>{point.y}</b>'
      },
      title: '',
      yAxis: {
        title: ''
      },
      plotOptions: {
        pie: {
          innerSize: '70%',
          name: 'Количество',
          allowPointSelect: true,
          cursor: 'pointer',
          dataLabels: {
            enabled: false
          },
          showInLegend: true
        }
      },
      credits: {
        enabled: false
      },
      colors: [lightTeal, butterscotch, seafoamBlue]
    }
  },
  // кол-во отходов по классам опасности
  garbage: {
    options: {
      documentTitle: 'Количество отходов по классам опасности',
      legend: {
        enabled: false
      },
      chart: {
        type: 'column'
      },
      title: '',
      xAxis: {
        title: {
          text: 'класс опасности',
          style: { fontSize: 10 }
        }
      },
      yAxis: {
        title: {
          text: 'тыс.тонн/год',
          style: { fontSize: 10 }
        }
      },
      plotOptions: {
        series: {
          animation: {
            duration: 400
          }
        }
      },
      tooltip: {
        pointFormat: '<b>{point.y}</b>'
      },
      credits: {
        enabled: false
      },
      colors: [blue]
    }
  },
  // динамика исполн целевых показателей
  dynamic: {
    series: [{
      ...fillColorPlanOptions,
      data: []
    }, {
      ...fillColorFactOptions,
      data: []
    }],
    options: {
      documentTitle: 'Динамика исполнения целевых показателей',
      chart: {
        type: 'area'
      },
      title: '',
      xAxis: {
        labels: {
          formatter: function () {
            if (isFloat(this.value)) {
              return null
            }
            return this.value
          }
        }
      },
      yAxis: {
        title: ''
      },
      plotOptions: {
        area: {
          pointStart: 2000,
          pointInterval: 1
        },
        series: {
          dataLabels: {
            enabled: false,
            formatter: function () {
              if (this.y != 0) {
                return '<b>' + this.y + '</b>'
              }
            }
          }
        }
      },
      credits: {
        enabled: false
      },
      colors: [azul, red]
    }
  }
}

export default region.getRegionConfig({
  default: chartOptionsData,
  [KURGAN]: merge(
    cloneDeep(chartOptionsData),
    {
      garbageVolume: {
        options: {
          documentTitle: 'Соотношение образования отходов по группам, %',
        }
      },
      msnContainer: {
        options: {
          documentTitle: 'Контейнерные площадки',
        }
      },
      garbageOutput: {
        options: {
          documentTitle: 'Распределение отходов\n',
        }
      }
    }
  )
})
